document.addEventListener('alpine:init', () => {
  Alpine.data('FAQ', () => ({
    categories: [],
    faq_items: [],
    current_category: '',
    init() {
      let categories = JSON.parse(this.$el.dataset.categories);
      this.categories = categories;
      this.current_category = categories.length > 0 ? categories[0].title : '';

      let faq_items = JSON.parse(this.$el.dataset.faq_items);
      this.faq_items = faq_items;

      this.$watch('current_category', (value) => {
        // move to top
        window.scrollTo({ top: this.$el.closest('section').offsetTop, behavior: 'smooth' });
      });
    }
  }));
});